import { useCartTimeout } from "./useCartTimeout";

export const CartTimeout = () => {
    useCartTimeout();

    return null;
};
